import { Route, Routes } from 'react-router-dom';
import { ProductSummariesPage } from './ProductSummariesPage';
import { NewProductPage } from './NewProductPage';
import { UpdateProductPageRoot } from './UpdateProduct/UpdateProductPageRoot';

export const ProductPageRoot = () => (
  <Routes>
    <Route path='/new' element={<NewProductPage />} />
    <Route path='/:productID/*' element={<UpdateProductPageRoot />} />
    <Route path='*' element={<ProductSummariesPage />} />
  </Routes>
);
